/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Registration_PendingInputs */

const en_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (Partners)`)
};

const de_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (Gesellschafter)`)
};

const fr_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (associés)`)
};

const es_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (socios)`)
};

const it_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (Soci)`)
};

const nl_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (vennoten)`)
};

const pl_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (Wspólnicy)`)
};

const fi_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (yhtiömiehet)`)
};

const da_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (partnere)`)
};

const sv_impressum_registration_pending = /** @type {(inputs: Impressum_Registration_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (delägare)`)
};

/**
* | output |
* | --- |
* | "Vaisakhan Arackal Sanu & Chris Zanfir (Partners)" |
*
* @param {Impressum_Registration_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_registration_pending = /** @type {((inputs?: Impressum_Registration_PendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Registration_PendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_registration_pending(inputs)
	if (locale === "fr") return fr_impressum_registration_pending(inputs)
	if (locale === "es") return es_impressum_registration_pending(inputs)
	if (locale === "it") return it_impressum_registration_pending(inputs)
	if (locale === "nl") return nl_impressum_registration_pending(inputs)
	if (locale === "pl") return pl_impressum_registration_pending(inputs)
	if (locale === "fi") return fi_impressum_registration_pending(inputs)
	if (locale === "da") return da_impressum_registration_pending(inputs)
	if (locale === "sv") return sv_impressum_registration_pending(inputs)
	return en_impressum_registration_pending(inputs)
});